/**
 * Checkout address tracing hooks (call sites preserved; output disabled).
 */
export function isCheckoutAddressDebugEnabled(): boolean {
  return false;
}

export function logCheckoutAddress(_stage: string, _detail?: unknown): void {}

export function warnCheckoutAddress(_stage: string, _detail?: unknown): void {}
